import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar({ userSummary, onLogout }) {
  const location = useLocation();

  const navStyle = {
    backgroundColor: '#333',
    padding: '1rem',
    marginBottom: '2rem',
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  const navLinksStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
  };

  const linkStyle = {
    color: 'white',
    textDecoration: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    transition: 'background-color 0.2s',
  };

  const activeLinkStyle = {
    ...linkStyle,
    backgroundColor: '#555',
  };

  const userInfoStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    color: 'white',
  };

  const avatarStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
  };

  const logoutButtonStyle = {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  };

  return (
    <nav style={navStyle}>
      <div style={containerStyle}>
        <div style={navLinksStyle}>
          <Link 
            to="/" 
            style={location.pathname === '/' ? activeLinkStyle : linkStyle}
          >
            Homepage
          </Link>
          <Link 
            to="/tracked" 
            style={location.pathname === '/tracked' ? activeLinkStyle : linkStyle}
          >
            Tracked Accounts
          </Link>
          <Link 
            to="/leaderboards" 
            style={location.pathname === '/leaderboards' ? activeLinkStyle : linkStyle}
          >
            Leaderboards
          </Link>
          <Link 
            to="/steam-status-update" 
            style={location.pathname === '/steam-status-update' ? activeLinkStyle : linkStyle}
          >
            Steam status update
          </Link>
        </div>
        
        {userSummary && (
          <div style={userInfoStyle}>
            <img 
              src={userSummary.avatar} 
              alt="User avatar" 
              style={avatarStyle}
            />
            <span>{userSummary.nickname}</span>
            <button 
              onClick={onLogout}
              style={logoutButtonStyle}
            >
              Log Out
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;